<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style >
html,
body,
#app {
  padding: 0px;
  margin: 0px;
  height: 100%;
}

.el-form-item__label {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.el-row-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
   margin-left: 10px;
}
/* .el-form-item__label{
  overflow:hidden;
  text-overflow:ellipsis; 
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:1;
} */
</style>


// WEBPACK FOOTER //
// src/App.vue